import { CheckSquare, ListChecks, Square } from "@phosphor-icons/react";
import { route } from "../urls";
import BgGoo from "./api-playground/bg-goo";

export default function ModelCreationOnboarding({
  username,
  name,
  description,
  hasExamples,
  showCommandLineMessage,
}: {
  username: string;
  name: string;
  description: string | null;
  hasExamples: boolean;
  showCommandLineMessage: boolean;
}) {
  return (
    <div className="flex border border-r8-gray-12 my-lh relative">
      <div className="relative flex items-center justify-center w-1/2 min-w-16 overflow-hidden bg-gradient-to-t from-branding-red to-branding-pink border-r border-r8-gray-12">
        <div className="absolute inset-0 opacity-50">
          <BgGoo speed={0.8} resolution={2} depth={4} />
        </div>
        <ListChecks
          size={64}
          weight="thin"
          className="z-[1] fill-white size-12 sm:size-16"
        />
      </div>
      <div className="p-lh max-w-xl">
        <h2 className="font-heading text-r8-xl sm:text-r8-2xl pb-3">
          <span className="font-semibold text-transparent bg-clip-text bg-gradient-to-br from-branding-red to-branding-pink">
            Your model is published.
          </span>{" "}
          Help people find it.
        </h2>

        <div className="py-1 flex items-center gap-3 text-r8-gray-10 line-through">
          <CheckSquare
            weight="fill"
            className="fill-r8-gray-8 shrink-0"
            size={24}
          />
          <label>Get your model on Replicate</label>
        </div>

        {description ? (
          <div className="py-1 flex items-center gap-3 text-r8-gray-10 line-through">
            <CheckSquare
              weight="fill"
              className="fill-r8-gray-8 shrink-0"
              size={24}
            />
            <label>Add a description</label>
          </div>
        ) : (
          <div className="py-1 flex items-start gap-3">
            <Square
              weight="thin"
              className="fill-r8-gray-12 shrink-0"
              size={24}
            />
            <div className="flex flex-col gap-0.5">
              <a
                href={route("model_update", {
                  username: username,
                  name: name,
                })}
              >
                Add a description
              </a>
              <p className="text-r8-gray-11 text-r8-sm">
                A one-liner to describe your model, like "Detects hotdogs in an
                image"
              </p>
            </div>
          </div>
        )}

        {hasExamples ? (
          <div className="py-1 flex items-center gap-3 text-r8-gray-10 line-through">
            <CheckSquare
              weight="fill"
              className="fill-r8-gray-8 shrink-0"
              size={24}
            />
            <label>Add some examples</label>
          </div>
        ) : (
          <div className="py-1 flex items-start gap-3">
            <Square
              weight="thin"
              className="fill-r8-gray-12 shrink-0"
              size={24}
            />
            <div className="flex flex-col gap-0.5">
              <a
                href={route("example_list", {
                  username: username,
                  name: name,
                })}
              >
                Add some examples
              </a>
              <p className="text-r8-gray-11 text-r8-sm">
                Models with examples are more discoverable, might be featured on
                the Explore page, and help users understand how to use them.
              </p>
            </div>
          </div>
        )}

        {showCommandLineMessage && (
          <p className="mt-3 text-r8-sm">
            You can also push a new version via the command line.{" "}
            <a href="https://replicate.com/docs/guides/push-a-model">
              Learn more
            </a>
            .
          </p>
        )}
      </div>
    </div>
  );
}
